import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { ExportFileComponent } from "./export-file.component";

@NgModule({
  declarations: [ExportFileComponent],
  imports: [CoreModule],
  exports: [ExportFileComponent],
})
export class ExportFileModule {}
